<template>
    <div class="archives-list-empty">
        <img class="" src="/static/img/empty-filter-result.png" />
        <div>{{ $t("chatbotv2.noResultFound") }}</div>
        <div>{{ $t("chatbotv2.checkYourFilterCombination") }}</div>
        <div>
            {{ $t("chatbotv2.or") }}
            <span class="link" @click="clearFilters"> {{ $t("chatbotv2.clearYourSearch") }}</span>
            {{ $t("chatbotv2.andTryAgain") }}
        </div>
    </div>
</template>

<script>
export default {
    name: "EmptyFilterResult",
    props: {
        clearFilters: {
            type: Function,
        },
    },
};
</script>

<style scoped lang="scss">
.archives-list-empty {
    align-items: center;
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: center;
    min-height: 300px;

    img {
        width: 200px;
    }

    div {
        margin-bottom: 5px;
        margin-top: 10px;
        color: #22272d;
        font-weight: 600;

        font-size: 16px;
        line-height: 20px;

        .link {
            cursor: pointer;
            transition: all 0.3s;
            color: #008aff;
            text-decoration: underline;
        }
    }

    div:first-child {
        font-size: 18px;
        line-height: 23px;
    }
}
</style>
